import { render } from "./ClientesDetalle.vue?vue&type=template&id=62033ccc&scoped=true"
import script from "./ClientesDetalle.vue?vue&type=script&lang=js"
export * from "./ClientesDetalle.vue?vue&type=script&lang=js"

import "./ClientesDetalle.vue?vue&type=style&index=0&id=62033ccc&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62033ccc"]])

export default __exports__